"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var lodash_1 = require("lodash");
var ClassificationTableFooter = function (_a) {
    var classifications = _a.classifications;
    var _b = react_1.useState({
        Gross: 0,
        Long: 0,
        Net: 0,
        Short: 0,
    }), totalValues = _b[0], setTotalValues = _b[1];
    react_1.useEffect(function () {
        setTotalValues({
            Short: lodash_1.sumBy(classifications, 'Short'),
            Long: lodash_1.sumBy(classifications, 'Long'),
            Gross: lodash_1.sumBy(classifications, 'Gross'),
            Net: lodash_1.sumBy(classifications, 'Net'),
        });
    }, [classifications]);
    return (react_1.default.createElement(core_1.TableFooter, null, classifications && (react_1.default.createElement(StyledTableRowData, null,
        react_1.default.createElement(ClassificationTableCellData, { style: { fontWeight: 'bold' } }, "Total"),
        react_1.default.createElement(TotalValueTableCell, null, totalValues.Long !== 0 ? totalValues.Long.toFixed(3) : undefined),
        react_1.default.createElement(TotalValueTableCell, null, totalValues.Short !== 0 ? totalValues.Short.toFixed(3) : undefined),
        react_1.default.createElement(TotalValueTableCell, null, totalValues.Gross !== 0 ? totalValues.Gross.toFixed(3) : undefined),
        react_1.default.createElement(TotalValueTableCell, { colSpan: 2 }, totalValues.Net !== 0 ? totalValues.Net.toFixed(3) : undefined),
        react_1.default.createElement(TotalValueTableCell, { style: { width: '40%' } })))));
};
exports.default = ClassificationTableFooter;
var TotalValueTableCell = styled_components_1.default(core_1.TableCell)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    color: black;\n    font-weight: bold;\n    padding: 0 9px 4px 9px;\n    text-align: right;\n    font-size: 12px;\n  }\n"], ["\n  && {\n    color: black;\n    font-weight: bold;\n    padding: 0 9px 4px 9px;\n    text-align: right;\n    font-size: 12px;\n  }\n"])));
var StyledTableRowData = styled_components_1.default(core_1.TableRow)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  && {\n    height: 30px;\n  }\n"], ["\n  && {\n    height: 30px;\n  }\n"])));
var ClassificationTableCellData = styled_components_1.default(core_1.TableCell)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  && {\n    color: black;\n    font-size: 12px;\n    padding: 5px 9px 3px 9px;\n  }\n"], ["\n  && {\n    color: black;\n    font-size: 12px;\n    padding: 5px 9px 3px 9px;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3;
